import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import 'rxjs/add/operator/map';
import { Filter } from '../_models/filter';
import { AuthenticationService } from '../_services/authentication.service';
import { EnvironmentService } from './index';


@Injectable()
export class FiltersService { 
  private baseUrl: string = this.environmentService.getBaseURL() + '/api';

  constructor(
    private http: Http,
    private authenticationService: AuthenticationService,
    private environmentService: EnvironmentService) {
  }


  getAll(): Observable<Filter[]>{
    let filters$ = this.http
      .get(`${this.baseUrl}/filters`, this.makeHeaders())
      .map(mapFilters)
      .catch(handleError);
    return filters$;
  }
  get(id: string): Observable<Filter> {
    let filter$ = this.http
      .get(`${this.baseUrl}/filters/${id}`, this.makeHeaders())
      .map(mapFilter);
    return filter$;
  }
  create(filter : Filter) : Observable<Filter>{
    let newfilter = this.http
      .post(`${this.baseUrl}/filters`, JSON.stringify(filter), this.makeHeaders())
      .map(mapFilter);
    return newfilter;
  }
  update(filter: Filter) : Observable<Response>{
    return this.http
      .put(`${this.baseUrl}/filters/${filter._id}`, JSON.stringify(filter), this.makeHeaders());
  }
  delete(id: string) : Observable<Response>{
    return this.http
      .delete(`${this.baseUrl}/filters/${id}`, this.makeHeaders())
        .map((res:Response) => res.json()) // ...and calling .json() on the response to return data
        .catch((error:any) => Observable.throw(error.json().error || 'Server error')); //...errors if any
  }

  private makeHeaders():RequestOptions {
    let headers = new Headers();
    headers.append('Authorization', this.authenticationService.getToken());
    headers.append('Content-Type', 'application/json ');
    headers.append('charset', 'UTF-8 ');
    headers.append('Accept', 'application/json ');
    let options = new RequestOptions({ headers: headers });
    return options;
  }
}
function mapFilters(response:Response): Filter[]{
   // uncomment to simulate error:
   // throw new Error('ups! Force choke!');
   return response.json().map(toFilter);
}

function toFilter(r:any): Filter{
  let filter = <Filter>({
    _id: r._id,
    filtername: r.filtername,
    file_type: r.file_type,
    character_encoding: r.character_encoding,
    delimiter: r.delimiter,
    name: r.name,
    email: r.email,
    firstreg: r.firstreg,
    regnr: r.regnr,
    gruppe: r.gruppe,
    sex: r.sex,
    chassisnummer: r.chassisnummer,
    filterdata: r.filterdata
  });
  return filter;
}

function mapFilter(response:Response): Filter{
  // toPerson looks just like in the previous example
  return toFilter(response.json());
}

// this could also be a private method of the component class
function handleError (error: any) {
  // log error
  // could be something more sofisticated
  let errorMsg = error.message || `Yikes! There was was a problem with our hyperdrive device and we couldn't retrieve your data!`
  console.error(errorMsg);

  // throw an application level error
  return Observable.throw(errorMsg);
}



// WEBPACK FOOTER //
// ./src/app/_services/filters.service.ts